import React from 'react';
import Sidebar from './Sidebar';
import UnitToggle from '../UnitToggle';
import DarkModeToggle from '../DarkModeToggle';
import Footer from './Footer';
import '../../styles/layout/DashboardLayout.css';
import { useAuth } from '../../contexts/AuthContext';
import { useDebug } from '../../contexts/DebugContext';

const DashboardLayout = ({ 
  children, 
  sections, 
  activeSection, 
  setActiveSection, 
  isProCalculator,
  onSaveProject = () => {},
  onManageProjects = () => {},
  isMetric,
  setIsMetric,
  isMetricWeight,
  setIsMetricWeight,
  isDarkMode,
  setIsDarkMode,
  calculatorVersion,
  setCalculatorVersion,
  sectionCompletionStatus = {},
  noWrapperStyling = false
}) => {
  
  const { user } = useAuth(); // Get user from auth context
  const { isDebugMode, toggleDebugMode } = useDebug(); // Get debug state and toggle function
   
  // Check if the user is the specific debug user
  const isDebugUser = user?.email === 'familyvandiverhouse@gmail.com';

  return (
    <div className="dashboard-layout">
      <Sidebar 
        sections={sections} 
        activeSection={activeSection} 
        setActiveSection={setActiveSection}
        isProCalculator={isProCalculator}
        onSaveProject={onSaveProject}
        onManageProjects={onManageProjects}
        setCalculatorVersion={setCalculatorVersion}
        sectionCompletionStatus={sectionCompletionStatus}
      />
      <div className="dashboard-content">
        {/* Sticky Header Container */}
        <div className="dashboard-sticky-header">
          {/* Header for toggles - Hiding toggles for now */}
          {/* <div className="dashboard-header-toggles">
            <div className="unit-toggle-item">
              <span className="unit-toggle-label">Length:</span>
              <UnitToggle 
                checked={isMetric} 
                onChange={setIsMetric} 
                leftLabel="in"
                rightLabel="mm"
                id="dashboard-length-unit-toggle"
              />
            </div>
            <div className="unit-toggle-item">
              <span className="unit-toggle-label">Weight:</span>
              <UnitToggle 
                checked={isMetricWeight} 
                onChange={setIsMetricWeight}
                leftLabel="oz"
                rightLabel="g"
                id="dashboard-weight-unit-toggle"
              />
            </div>
          </div> */}
          
          {/* Debug Toggle - Only visible for specific user */}      
          {isDebugUser && (
            <div className="debug-toggle-container" style={{ marginRight: '20px', display: 'flex', alignItems: 'center' }}> 
              <span style={{ marginRight: '10px', fontWeight: '500' }}>Debug Mode:</span>
              <UnitToggle
                id="debug-mode-toggle"
                checked={isDebugMode}
                onChange={toggleDebugMode}
                leftLabel="Off"
                rightLabel="On"
              />
            </div>
          )}

          {/* Dark Mode Toggle */} 
          <div className="dark-mode-toggle-container" style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
             {/* Corrected prop names: isDarkMode -> isDark, setIsDarkMode -> onToggle */}
             <DarkModeToggle isDark={isDarkMode} onToggle={setIsDarkMode} /> 
          </div>

          <div className="attribution">
            Brought to you by <a href="https://TheCookiedBaker.com" target="_blank" rel="noopener noreferrer">The Cookied Baker</a>
          </div>
        </div>
        
        <div className={`content-wrapper ${noWrapperStyling ? 'content-wrapper--account-variant' : ''}`}>
          {children}
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default DashboardLayout;
